import { Loader2 } from "lucide-react";
import React from "react";
import { cn } from "../../../lib/utils";

export type InlineLoadingSpinnerProps = {
  message?: string;
  subtitle?: string;
  className?: string;
};

export const InlineLoadingSpinner: React.FC<InlineLoadingSpinnerProps> = ({
  message = "Loading...",
  subtitle,
  className,
}) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center gap-2 px-4 py-10 text-sm text-[#737373]",
      className,
    )}
  >
    <div className="flex items-center gap-2">
      <Loader2 className="h-4 w-4 animate-spin" />
      {message}
    </div>
    {subtitle && <p className="text-xs text-[#737373]">{subtitle}</p>}
  </div>
);
